import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Mail } from "lucide-react";
import { AUTHOR, SITE } from "@/lib/site";

const LegalDialog = ({ triggerLabel, testId, title, children }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button
        data-testid={testId}
        className="text-sm text-muted-foreground underline-offset-4 transition-colors hover:text-[hsl(var(--brand-ink))] hover:underline"
      >
        {triggerLabel}
      </button>
    </DialogTrigger>
    <DialogContent className="max-h-[80vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="font-heading">{title}</DialogTitle>
      </DialogHeader>
      <div className="space-y-3 text-sm leading-relaxed text-muted-foreground">{children}</div>
    </DialogContent>
  </Dialog>
);

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[hsl(var(--border))] bg-white">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 sm:px-6">
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:items-start md:justify-between md:text-left">
          <div className="max-w-sm">
            <p className="font-heading text-lg font-extrabold text-[hsl(var(--brand-ink))]">
              {SITE.title}
            </p>
            <p className="mt-1 text-sm text-muted-foreground">{SITE.subtitle}</p>
            <p className="mt-3 text-xs text-muted-foreground">
              Producto digital creado con amor por {AUTHOR}.
            </p>
          </div>

          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            <LegalDialog triggerLabel="Política de Privacidad" testId="footer-privacy-link" title="Política de Privacidad">
              <p>En {SITE.title} respetamos tu privacidad. Los datos que compartes durante la compra (nombre y correo) se utilizan únicamente para entregarte el producto digital y brindarte soporte.</p>
              <p>El pago es gestionado de forma segura por la plataforma Hotmart, que cuenta con sus propias políticas de protección de datos. No almacenamos información de tu tarjeta.</p>
              <p>No compartimos ni vendemos tu información a terceros. Si deseas que eliminemos tus datos, contáctanos y lo haremos a la brevedad.</p>
            </LegalDialog>

            <LegalDialog triggerLabel="Términos y Condiciones" testId="footer-terms-link" title="Términos y Condiciones">
              <p>Al adquirir este ebook aceptas que se trata de un <strong>producto digital descargable</strong> para uso personal y familiar.</p>
              <p>Puedes imprimirlo cuantas veces desees para tu familia. No está permitida su reventa, redistribución ni uso comercial sin autorización del autor.</p>
              <p>Contamos con una garantía de devolución de 7 días. Si no quedas satisfecho, escríbenos dentro de ese plazo para recibir el reembolso del 100%.</p>
              <p>Los colores de impresión pueden variar según tu impresora y el tipo de papel utilizado.</p>
            </LegalDialog>

            <LegalDialog triggerLabel="Contacto" testId="footer-contact-link" title="Contacto">
              <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[hsl(var(--brand-coral))]" /> ¿Tienes dudas antes o después de tu compra?</p>
              <p>Escríbenos y con gusto te ayudamos. Respondemos lo antes posible para que tu experiencia sea perfecta.</p>
              <p className="font-semibold text-[hsl(var(--brand-ink))]">contacto@creativesmar.com</p>
            </LegalDialog>
          </nav>
        </div>

        <div className="mt-8 border-t border-[hsl(var(--border))] pt-6 text-center">
          <p className="text-xs text-muted-foreground">
            © {year} {AUTHOR}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
